module.exports = __webpack_public_path__ + "img/3.da6f6c55.png";